export default __webpack_public_path__ + "static/media/girlDog.016adfe1.svg";